import React, { Component } from "react";
import { connect } from "react-redux";
import AlertLineGraph from "../AlertLineGraph";
import FontAwesome from "react-fontawesome";
import { api } from "../../_services";
import { getSensorData, filteredSensorDataList, setTelemetryAlertData } from "../../_actions";
import "./index.css";

class AlertCardTelemetry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTelemetry: this.props.show,
      loading: true
    };
  }

  componentDidMount = () => {};

  componentWillReceiveProps = nextProps => {
    this.setState(() => {
      return {
        showTelemetry: nextProps.show
      };
    });
    if (nextProps.show) {
      this.getSensorDataList();
    }
  };

  closeAlertTelemetryPanel = () => {
    this.props.togglePanel(false);
    this.setState(() => {
      return {
        showTelemetry: false
      };
    });
  };

  /* Method to get the telemetry data */
  getSensorDataList = () => {
    if (!this.props.alert.telemetry_sets || this.props.alert.telemetry_sets.length < 1) {
      return null;
    }

    const alertTelemetry = this.props.alert.telemetry_sets;

    const deviceId = alertTelemetry[0].device;

    const url = "/api/v1/devices/" + deviceId + "/telemetry/";

    const params = {
      telemetry_types: alertTelemetry[0].telemetry_type_id,
      aggregation_type: alertTelemetry[0].aggregation_type_id,
      aggregation_period: alertTelemetry[0].aggregation_period_id,
      start_time: alertTelemetry[0].suggested_display_window_start,
      end_time: alertTelemetry[0].suggested_display_window_end,
      max_records: 10000,
      include_alert_traces: true
    };

    const errorMsg = "Unable to get the alert telemetry data.";

    api
      .getFetch(url, params, this.props.user.token, errorMsg)
      .then(json => {
        if (json.telemetry_sets.length > 0) {
          this.props.getSensorData(json.telemetry_sets);
          this.props.setTelemetryAlertData(json.alert_traces);
          this.setState(() => {
            return {
              completeSensorDataList: json.telemetry_sets,
              sensorDataList: json.telemetry_sets[0].columns,
              telemetryAlertDataList: json.alert_traces,
              loading: false
            };
          });
        }
      })
      .then(() => {
        if (this.state.sensorDataList) {
          this.filterSensorData();
        }
      });
  };

  filterSensorData = () => {
    if (!this.props.alert) {
      return null;
    }
    const tmpFilteredData = [];
    tmpFilteredData.push(this.state.sensorDataList[0]);
    if (this.props.alert.telemetry_sets[0].series_id) {
      for (let i = 0; i < this.state.sensorDataList.length; i++) {
        if (this.state.sensorDataList[i].id === this.props.alert.telemetry_sets[0].series_id) {
          tmpFilteredData.push(this.state.sensorDataList[i]);
        }
      }
    } else {
      tmpFilteredData.push(this.state.sensorDataList[1]);
    }

    this.setState(() => {
      return {
        filteredDataList: tmpFilteredData
      };
    });
    this.props.filteredSensorDataList(tmpFilteredData);
  };

  renderDeviceID = () => {
    if (!this.props.alert.devices[0]) {
      return "-";
    } else {
      return this.props.alert.devices[0].device_id;
    }
  };

  renderDeviceName = () => {
    if (!this.props.alert.devices[0]) {
      return "-";
    } else {
      return this.props.alert.devices[0].name;
    }
  };

  renderDeviceType = () => {
    if (!this.props.alert.devices[0]) {
      return "-";
    } else {
      return this.props.alert.devices[0].device_type_display;
    }
  };

  renderMetadata = () => {
    if (!this.props.alert) {
      return null;
    }
    return (
      <div>
        <div className="row-title">Meta Data</div>
        <div className="row metadata-row">
          <div className="col-md-12 metadata-key">Device ID</div>
          <div className="col-md-12">{this.renderDeviceID()}</div>
        </div>
        <div className="row metadata-row">
          <div className="col-md-12 metadata-key">Device Name</div>
          <div className="col-md-12">{this.renderDeviceName()}</div>
        </div>
        <div className="row metadata-row">
          <div className="col-md-12 metadata-key">Device Type</div>
          <div className="col-md-12">{this.renderDeviceType()}</div>
        </div>
      </div>
    );
  };

  renderCloseButton = item => {
    if (item !== "alertPanel") {
      return null;
    }

    return (
      <span className="exit" onClick={this.closeAlertTelemetryPanel}>
        <FontAwesome name="window-close" />
      </span>
    );
  };

  renderGraph = () => {
    if (this.state.loading) {
      return <div className="loading-con">Loading telemetry</div>;
    } else {
      return (
        <AlertLineGraph
          height={300}
          completeSensorDataList={this.state.completeSensorDataList}
          sensorDataList={this.state.sensorDataList}
          filteredDataList={this.state.filteredDataList}
          telemetryAlertDataList={this.state.telemetryAlertDataList}
          start={this.props.alert.telemetry_start_time}
          end={this.props.alert.telemetry_end_time}
          closed={this.props.alert.closed}
        />
      );
    }
  };

  render = () => {
    if (!this.props.alert) {
      return null;
    }

    return (
      <div className="alertTelemetryMainPanel" style={{ display: this.state.showTelemetry ? "block" : "none" }}>
        <div className="filterTitle">
          ALERT TELEMETRY
          {this.renderCloseButton(this.props.source)}
        </div>
        <div className="row">
          <div className="col-md-9">{this.renderGraph()}</div>
          <div className="col-md-3">{this.renderMetadata()}</div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps, {
  getSensorData,
  filteredSensorDataList,
  setTelemetryAlertData
})(AlertCardTelemetry);



// WEBPACK FOOTER //
// ./src/_components/AlertCardTelemetry/index.js